import React from 'react';

/** Circular score like the reference: thin number, "/ 100" underneath, gold arc over a dark track. */
export default function GlassScoreRing({ value, max = 100, size = 120 }) {
  const stroke = 9;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - Math.max(0, Math.min(value / max, 1)));
  return (
    <svg width={size} height={size} role="img" aria-label={`Score ${value} of ${max}`} style={{ flexShrink: 0 }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,.07)" strokeWidth={stroke} />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--g-gold)" strokeWidth={stroke} strokeLinecap="round"
        strokeDasharray={c} strokeDashoffset={offset} transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      <text x="50%" y={size / 2 - 2} textAnchor="middle" dominantBaseline="central" fill="var(--g-text)"
        fontSize={size * 0.24} fontWeight="400" fontFamily="Michroma, sans-serif">{value}</text>
      <text x="50%" y={size / 2 + size * 0.2} textAnchor="middle" fill="var(--g-muted)" fontSize={size * 0.085}
        fontFamily="Sora, sans-serif">/ {max}</text>
    </svg>
  );
}
